module.exports = "pegasus_template/assets/tech/email1-img10.png";